<template>
  <ValidationObserver v-slot="{handleSubmit, invalid, reset}" ref="observer">
    <artisio-modal :visible="showSettlementDaysModal"
                   :data="model"
                   :title="$t('Settlement Days')"
                   @show="onShow"
                   @hidden="onHidden"
                   @ok.prevent="handleSubmit(onSubmit)"
                   :show-confirmation="showConfirmation"
                   :ok-title="$t('Submit')"
                   :is-loading="loading"
                   scrollable>
      <input-widget :autofocus="true" ref="settlementDaysInput" :hint="true" :label="false" :model="model"
                    attribute="settlement_days" type="number"/>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>

  import {createNamespacedHelpers} from 'vuex';
  import ArtisioModal from "../../../../../core/components/artisio-modal/ArtisioModal";
  import InputWidget from "../../../../../core/components/input-widget/InputWidget";
  import SettlementDaysForm from "@/modules/customer/models/SettlementDaysForm.model";

  const {mapState, mapActions} = createNamespacedHelpers('reservations');
  const {mapState: globalMapState} = createNamespacedHelpers('global');

  export default {
    name: "SettlementDaysModal",
    components: {InputWidget, ArtisioModal},
    data: () => {
      return {
        loading: false,
        model: new SettlementDaysForm({}),
        showConfirmation: false
      }
    },
    methods: {
      ...mapActions(['toggleSettlementDaysModal', 'saveTermsPartialData']),
      async onSubmit() {
        this.loading = true;
        let response = await this.saveTermsPartialData({settlement_days: this.model.settlement_days});
        this.loading = false;

        if (response.success) {
          this.showConfirmation = false;
          await this.toggleSettlementDaysModal(false);
          this.$toast('success', this.$t('Settlement days were successfully saved'));
        } else {
          if (response.toastError) {
            this.$errorDialog(response.toastError);
          } else {
            this.model.setMultipleErrors(response.body);
          }
        }
      },
      onShow() {
        this.showConfirmation = true;
        this.model = new SettlementDaysForm({settlement_days: this.settlementDays || this.defaultSettlementDays});
      },
      onHidden() {
        this.model = new SettlementDaysForm();
        this.toggleSettlementDaysModal(false);
      },
    },
    watch: {
      settlementDays() {
        this.model = new SettlementDaysForm({settlement_days: this.settlementDays});
      }
    },
    computed: {
      ...globalMapState(['defaultSettlementDays']),
      ...mapState({
        showSettlementDaysModal: state => state.view.termsData.settlementDaysModal.show,
        settlementDays: state => state.view.termsData.settlement_days
      }),
    },
  }
</script>

<style lang="scss" scoped>
</style>

